import React, { useEffect, useRef } from 'react';
import debounce from 'lodash/debounce';

import styled from 'styled-components/macro';
import { revertedSmallElevationShadow, uiColors } from '../../common/styles';
import { slideInFromBottom } from '../checkout/styled';
import { useAppContext, useNavigation } from '../../context';
import PhotoUploadProgress from '../common/PhotoUploadProgress';

const ColumnWrapper = styled.div`
    position: ${(props) => (props.$isMobile ? 'fixed' : 'absolute')};
    bottom: 0;
    margin-bottom: 0;
    width: 100%;
    gap: 8px;
    display: flex;
    flex-direction: column;
    width: 100%;
    box-shadow: 0 -5px 5px rgba(0, 0, 0, 0.05);
    background: ${uiColors.WHITE};
    line-height: 1.2;
    padding: ${(props) => (props.$isSmall ? '4px 10px' : '8px 16px')};
    z-index: 3002;
`;

const Wrapper = styled.section`
    width: 100%;
    gap: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 150;
    transition: margin-bottom, background, box-shadow;
    transition-duration: 0.5s;
    transition-timing-function: ease-out;
    //border-radius: 0 0 0 12px;
    // animation: ${slideInFromBottom} 0.5s ease-in-out;
    overflow: hidden;
`;

const FloatingBottom = () => {
    const { smallHeightDevice, isMobile } = useAppContext();
    const {
        floatingBottomContent,
        setFloatingBottomHeight,
        setFloatingBottomVisible,
        activeDrawer,
        drawerContent
    } = useNavigation();
    const wrapperRef = useRef(null);

    useEffect(() => {
        const debouncedSetFloatingBottomHeight = debounce((height) => {
            setFloatingBottomHeight(height);
        }, 100);

        const resizeObserver = new ResizeObserver((entries) => {
            if (entries[0] && entries[0].borderBoxSize && entries[0].borderBoxSize[0]) {
                const { blockSize } = entries[0].borderBoxSize[0];
                debouncedSetFloatingBottomHeight(blockSize);
            }
        });

        const intersectionObserver = new IntersectionObserver(
            ([entry]) => {
                setFloatingBottomVisible(entry.isIntersecting);
            },
            { threshold: 0 }
        );

        if (wrapperRef.current) {
            resizeObserver.observe(wrapperRef.current);
            intersectionObserver.observe(wrapperRef.current);
        }

        return () => {
            resizeObserver.disconnect();
            intersectionObserver.disconnect();
        };
    }, [floatingBottomContent, setFloatingBottomHeight, setFloatingBottomVisible]);

    const content = floatingBottomContent && (
        <ColumnWrapper ref={wrapperRef} $isMobile={isMobile}>
            <Wrapper $isSmall={smallHeightDevice} $isMobile={isMobile}>
                {floatingBottomContent}
            </Wrapper>
            <PhotoUploadProgress />
        </ColumnWrapper>
    );

    return content;
};

export default FloatingBottom;
